module.exports = __webpack_public_path__ + "img/coinbankB24.99e57bdd.jpg";